import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'arquivo-extrato-file-input',
    template: `
        <input #inputFile
               type="file"
               id="uploadFile_{{data}}"
               name="uploadFile_{{data}}"
               hidden
               (change)="onSelectionChange($event.target.files)"
               accept=".ofx,.txt"/>
    `,
    styles: [``]
})
export class ArquivoExtratoFileInputComponent implements OnInit {

    @ViewChild('inputFile', {static: true}) inputFile: ElementRef;

    @Output() selecionado = new EventEmitter();

    data: any = {};

    constructor() {
    }

    ngOnInit() {
        this.data = Date.now();
    }

    onSelectionChange(files: any) {
        if (files && files.length > 0) {
            this.selecionado.emit(files);
        }
        // necessário para ativar o método change ao subir o mesmo arquivo
        setTimeout(() => {
            this.inputFile.nativeElement.value = '';
        }, 100);
    }

    triggerClick(): void {
        this.inputFile.nativeElement.click();
    }
}
